import { useEffect } from "react";
import useAuth from "../store/useAuth"
import { GetUserByPhoneNumber } from "../API/authApiservice";

export const useAuthInitalizer = () => {
    const { setIsRegistred, setIsLoading, setUser, clearUser } = useAuth();
    
    useEffect(() => {
        const initilizeAuth = async () => {
            // CRITICAL FIX: Check if we're in the first-time flow
            const appInitialized = localStorage.getItem("appInitialized");;
            const isFirstTime = !localStorage.getItem("appVisited");
            
            // If we're in first-time flow or initialization, don't run auth initialization
            // This prevents the race condition with RouteHandler
            if (isFirstTime || appInitialized === "initializing") {
                return;
            }
            setIsLoading(true);
            try {
                const token = localStorage.getItem("token");
                const phoneNumber = sessionStorage.getItem("lastVerifiedPhone") || localStorage.getItem("phoneNumber");
                
                if (token && phoneNumber) {
                    const user = await GetUserByPhoneNumber(phoneNumber);
                    if (user) {
                        setIsRegistred(true);
                    }
                    else {
                        clearUser();
                        localStorage.removeItem("phoneNumber");
                    }
                }
                else {
                    clearUser();
                }
            }
            catch {
                clearUser();
            }
            finally {
                setIsLoading(false);
            }
        };
        
        initilizeAuth();
    }, [setIsLoading, setIsRegistred, setUser, clearUser]);

}

export default useAuthInitalizer;